<template>
  <div
    v-if="typeof errors === 'object' && Object.keys(errors).length"
    class="alert alert-danger"
  >
    <p v-text="message" />
    <ul>
      <template v-for="errorCategory in errors">
        <template v-if="typeof errorCategory !== 'string'">
          <li
            v-for="error in errorCategory"
            v-text="error"
          />
        </template>
        <template v-else>
          <li v-text="errorCategory" />
        </template>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    errors: [Object, Array],
    message: {
      type: String,
      default: 'There were some errors while processing your request:'
    }
  },
}
</script>